import timeOffInputStore from "../store/store";
import { Moment } from "moment";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_END_DATE', function setEndDateInStore(endDate: Moment) {
    timeOffInputStore.endDate = endDate.clone();
});
